export enum NETS_LIB_URLS {
    PROD = 'https://checkout.dibspayment.eu/v1/checkout.js?v=1',
    TEST = 'https://test.checkout.dibspayment.eu/v1/checkout.js?v=1'
}